import { HeroFoldsBackdrop } from "../BrandBackdrop";
import { Skeleton } from "../ui/skeleton";

export const PlatformSkeleton = () => {
  return (
    <div
      className="min-h-screen bg-background"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading"
      style={{ backgroundColor: "#07121A" }}
    >
      <section className="relative pt-28 lg:pt-36 pb-0 overflow-hidden">
        <HeroFoldsBackdrop />
        <div className="container mx-auto px-4 lg:px-8 relative z-10 pb-16 lg:pb-24">
          <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
            <div className="lg:col-span-7">
              <Skeleton className="h-5 w-56 rounded-full bg-vestn-cream/10 mb-6" />
              <h1 className="text-5xl sm:text-6xl lg:text-7xl xl:text-[5.5rem] font-bold leading-[1.02] tracking-[-0.02em] mb-6 text-left">
                <span className="block text-vestn-cream">Own more.</span>
                <span className="block text-primary">Risk less.</span>
              </h1>
              <p className="text-lg lg:text-xl text-vestn-cream/70 leading-relaxed max-w-xl mb-9">
                The application layer for tokenization, connecting eligible
                capital with institutional assets through SPV structures.
                Investor preview only; capital is at risk, including total loss.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 mb-14">
                <Skeleton className="h-12 w-full sm:w-48 rounded-lg bg-vestn-cream/10" />
                <Skeleton className="h-12 w-full sm:w-44 rounded-lg bg-vestn-cream/10" />
              </div>
              <div>
                <div className="h-px bg-vestn-cream/15 mb-5" />
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-6">
                  {Array.from({ length: 4 }).map((_, i) => (
                    <div key={i} className="px-4 lg:px-6 first:pl-0">
                      <Skeleton className="h-7 w-16 bg-vestn-cream/10 mb-2" />
                      <Skeleton className="h-3 w-20 bg-vestn-cream/10" />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="lg:col-span-5">
              <div className="relative rounded-2xl bg-[#0A1A24] border border-vestn-cream/10 overflow-hidden">
                <div className="h-[2px] bg-primary" aria-hidden="true" />
                <div className="p-6 lg:p-7">
                  <div className="flex items-center justify-between mb-5">
                    <span className="text-[10px] tracking-[0.18em] uppercase text-vestn-cream/60 font-medium">
                      Featured Offering
                    </span>
                  </div>
                  <Skeleton className="h-7 w-48 bg-vestn-cream/10 mb-2" />
                  <Skeleton className="h-4 w-32 bg-vestn-cream/10 mb-6" />
                  <div className="grid grid-cols-2 gap-x-6 gap-y-5 mb-6">
                    {Array.from({ length: 4 }).map((_, i) => (
                      <div key={i}>
                        <Skeleton className="h-3 w-16 bg-vestn-cream/10 mb-1.5" />
                        <Skeleton className="h-5 w-14 bg-vestn-cream/10" />
                      </div>
                    ))}
                  </div>
                  <Skeleton className="h-1 w-full rounded-full bg-vestn-cream/10 mb-6" />
                  <Skeleton className="h-12 w-full rounded-xl bg-vestn-cream/10" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="bg-background">
        <div className="container mx-auto px-4 lg:px-8 py-24">
          <div className="text-center mb-14 max-w-2xl mx-auto">
            <Skeleton className="h-10 w-72 mx-auto mb-4" />
            <Skeleton className="h-5 w-full" />
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {Array.from({ length: 4 }).map((_, i) => (
              <div
                key={i}
                className="p-6 rounded-2xl bg-card border border-border space-y-3"
              >
                <Skeleton className="w-12 h-12 rounded-xl" />
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-3 w-full" />
                <Skeleton className="h-3 w-5/6" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
